// Bilingual content (IT / EN) for the whole site.

const it = {
  nav: {
    home: "Home",
    about: "Cos'è",
    innovation: "Innovazione",
    whatWeDo: "Cosa Facciamo",
    recipes: "Ricette",
    allf: "Mercati",
    contact: "Contatti",
  },
  common: {
    shop: "Shop",
    goShop: "Vai allo Shop",
    home: "Home",
    scroll: "Scorri",
    contactUs: "Contattaci",
    discoverAllf: "Scopri il progetto RISORICE®",
    docPdf: "Documento PDF",
  },
  footer: {
    tagline: "La cucina italiana, reinventata dall'innovazione. Startup innovativa che porta la cucina gourmet italiana in tutto il mondo.",
    naviga: "Naviga",
    progetti: "Progetti",
    projects: [
      { label: "ALLF - Il ristorante", key: "allf" },
      { label: "Progetto RISORICE®", key: "risorice" },
      { label: "MichelChef® Hotel", key: "hotel" },
    ],
    dove: "Dove siamo",
    rights: "P.IVA Startup Innovativa. Tutti i diritti riservati.",
    italyWorld: "Italia & Mondo",
  },
  home: {
    badge: "Startup Innovativa dal 2020",
    heroTitle1: "La cucina italiana,",
    heroTitle2: "reinventata.",
    heroSub: "Piatti gourmet in monoporzione, prodotti da uno Chef e rigenerati ovunque grazie a un brevetto che preserva aromi e sapori. Innovazione al servizio della tradizione.",
    heroCta1: "Scopri l'innovazione",
    heroCta2: "Hai un locale? Ci pensiamo noi",
    introEyebrow: "Chi siamo",
    introTitle: "Cos'è MichelChef®",
    introP: [
      "MichelChef® è una startup innovativa costituita a Marzo 2020 dallo Chef Michele Raccuia. Chef per passione e di origine torinese, si rimette in gioco all'età di 35 anni coniugando Passione, Tecnica e Vision in un progetto denominato ALLF.",
      "La sua idea di cucina stravolge completamente l'approccio alle tavole italiane, realizzando un format fatto di tanta qualità in piccole monoporzioni.",
    ],
    introLink: "La nostra storia",
    objEyebrow: "Innovazione",
    objTitle: "Il nostro obiettivo",
    objText: "Esportare le tradizioni della cucina italiana in tutto il mondo, facendo sempre leva sul nostro brevetto che ci consente di preservare aromi e sapori, rendendo la food experience del cliente costante ovunque.",
    objBadgeTitle: "Brevetto 2020",
    objBadgeSub: "Sferificazione molecolare",
    objFeatures: [
      { t: "Esportazione globale", d: "Tradizione italiana ovunque" },
      { t: "Food experience costante", d: "Stessa qualità in ogni piatto" },
    ],
    procEyebrow: "Il processo",
    procTitle: "Come funziona",
    procSub: "Dal laboratorio dello Chef alla tavola, senza mai perdere qualità.",
    procLink: "Scopri tutto il processo",
    chanEyebrow: "Mercati & Distribuzione",
    chanTitle: "Tre canali, un'unica qualità",
    ctaTitle: "Porta la cucina gourmet italiana nel tuo locale",
    ctaText: "Hotel, Bar o Ristorante con problemi in cucina? Con MichelChef® e ALLF offri piatti gourmet senza bisogno dello Chef.",
  },
  stats: [
    { value: "400+", label: "Ricette della tradizione" },
    { value: "2020", label: "Startup Innovativa" },
    { value: "3", label: "Canali distributivi" },
    { value: "150-200g", label: "Monoporzioni gourmet" },
  ],
  partners: ["Ristoranti & Delicatesse", "Chopped Italia", "Food Network", "LAINOX", "ALLF", "Camera di Commercio Ferrara"],
  steps: [
    { step: "01", title: "Creazione delle ricette", text: "Lo Chef, all'interno del laboratorio di produzione, crea le sue ricette che faranno parte dei piatti proposti. Oltre 400 ricette della tradizione culinaria italiana." },
    { step: "02", title: "Abbattimento & confezionamento", text: "Tutti i piatti vengono abbattuti sia positivamente (+4°) che negativamente (-20°) e confezionati in monoporzioni con pesi medi da 150gr a 200gr." },
    { step: "03", title: "Spedizione", text: "Provvediamo alla spedizione verso i ristoranti a marchio ALLF, di proprietà o affiliati, in Italia e nel mondo." },
    { step: "04", title: "Cottura automatizzata", text: "Nei punti ALLF i piatti gourmet vengono rigenerati con un processo di cottura automatizzato, senza la presenza dello Chef, garantendo qualità costante." },
  ],
  channels: [
    { tag: "Diretto", title: "Ristoranti ALLF", text: "Vendita diretta attraverso i ristoranti ALLF e i centri cottura ALLF Express." },
    { tag: "B2B", title: "Hotel, Bar & Ristoranti", text: "Fornitura ai canali professionali che vogliono offrire cucina gourmet senza il problema del cuoco." },
    { tag: "Distribuzione", title: "Distributori Horeca", text: "Rete di distributori Horeca che portano i nostri piatti gourmet a ristoranti, bar e hotel su tutto il territorio." },
  ],
  allfResto: {
    crumb: "ALLF · Il ristorante",
    eyebrow: "Ristorante · Fast-casual italiano",
    title: "ALLF: l'Italia in un morso, servita in un attimo",
    subtitle: "Un McDonald's tutto italiano: la velocità del fast-food incontra la cucina della tradizione. Piatti regionali rigenerati con processo automatizzato, sempre uguali a sé stessi, in ogni locale.",
    conceptEyebrow: "Il concept",
    conceptTitle: "Come un fast-food, ma 100% cucina italiana",
    conceptText: "ALLF porta i grandi piatti delle regioni italiane nel formato veloce che ami: ordini, la cucina automatizzata rigenera il piatto in pochi minuti e ritiri. Nessuno chef in sala, qualità gourmet costante ovunque.",
    pillars: [
      { t: "Veloce come un fast-food", d: "Piatto pronto in pochi minuti, senza rinunciare al gusto." },
      { t: "Cottura automatizzata", d: "Il brevetto MichelChef® rigenera i piatti senza cuoco in sala." },
      { t: "Qualità sempre uguale", d: "Stesso profumo e sapore in ogni locale ALLF, ovunque nel mondo." },
      { t: "Tutta l'Italia nel menu", d: "20 regioni, 2 piatti simbolo ciascuna: 40 specialità italiane." },
    ],
    procEyebrow: "Come funziona",
    procTitle: "Ordina, alla cucina pensa ALLF",
    proc: [
      { n: "01", t: "Ordina al totem o in app", d: "Scegli la regione e il tuo piatto in pochi tap." },
      { n: "02", t: "Cottura automatizzata", d: "Il piatto gourmet viene rigenerato in pochi minuti, sempre perfetto." },
      { n: "03", t: "Ritira e gusta", d: "Prendi il tuo piatto caldo al bancone. Buon appetito!" },
    ],
    menuEyebrow: "Il menu regionale",
    menuTitle: "Un viaggio nelle 20 regioni d'Italia",
    menuNote: "Seleziona una regione per scoprire i suoi 2 piatti simbolo.",
    regionsCount: "20 regioni",
    dishesCount: "40 piatti",
    signatureLabel: "Piatti simbolo",
    ctaTitle: "Porta ALLF nella tua città",
    ctaText: "Un format fast-casual italiano, automatizzato e replicabile. Scopri come aprire un ristorante ALLF.",
    ctaBtn: "Diventa partner",
    officialBtn: "Visita allf.it",
  },
  about: {
    crumb: "Cos'è", eyebrow: "Chi siamo", title: "Cos'è MichelChef®",
    subtitle: "Passione, Tecnica e Vision. La storia di uno Chef che ha deciso di reinventare il modo di portare la cucina italiana nel mondo.",
    storyEyebrow: "La storia", storyTitle: "Dallo Chef torinese al progetto ALLF",
    storyExtra: "In seguito ha voluto mettere a disposizione tutto il suo know-how realizzando un progetto altamente innovativo: una catena di ristoranti italiani, in tutto il mondo, che sfornano piatti gourmet grazie a un processo di cottura automatizzato e senza la presenza dello Chef.",
    quote: "\"Passione, Tecnica e Vision: coniugarle è la vera ricetta dell'innovazione.\"",
    founder: "Chef Michele Raccuia",
    pathEyebrow: "Il percorso", pathTitle: "Le tappe fondamentali",
    milestones: [
      { year: "2018", title: "Testimonial LAINOX", text: "Diventa testimonial di LAINOX, grande azienda italiana di strumenti professionali per la cucina." },
      { year: "2018", title: "Ristoranti & Delicatesse", text: "Ottiene l'inserimento nella prestigiosa rivista enogastronomica." },
      { year: "2018", title: "Chopped Italia", text: "Partecipa al celebre cooking show televisivo di Food Network." },
      { year: "2020", title: "Nasce MichelChef®", text: "A Marzo 2020 fonda la startup innovativa con il progetto ALLF." },
    ],
    ctaTitle: "Vuoi conoscere l'innovazione?", ctaText: "Scopri il brevetto e la tecnologia che rendono unica la nostra cucina.", ctaBtn: "Scopri il brevetto",
  },
  innovation: {
    crumb: "Innovazione", eyebrow: "Brevetto & Tecnologia", title: "L'innovazione in cucina",
    subtitle: "La sferificazione molecolare e un brevetto che preserva aromi e sapori: così la tradizione italiana viaggia nel mondo senza perdere nulla.",
    date: "12 Marzo 2020", patentTitle: "Il Brevetto",
    patentBody: "Lo Chef Michele Raccuia si presenta presso la Camera di Commercio di Ferrara e, davanti ad una commissione, mostra la sua innovazione in cucina attraverso la sferificazione molecolare. Al termine della presentazione la commissione iscrive la MichelChef® S.r.l. nella sezione dedicata alle Startup Innovative.",
    patentExtraPre: "Un processo che permette di abbattere e rigenerare i piatti mantenendo intatta la ",
    patentExtraHi: "food experience",
    patentExtraPost: ": stesso profumo, stesso sapore, ovunque nel mondo.",
    regEyebrow: "Registrazioni", regTitle: "Tutelati e certificati",
    regSub: "La MichelChef® S.r.l. è iscritta nella sezione Startup Innovative della Camera di Commercio di Ferrara.",
    registrations: [
      { label: "Marchio", desc: "Registrazione del marchio depositato" },
      { label: "Brevetto", desc: "Processo di conservazione aromi & sapori" },
      { label: "Disegno", desc: "Design industriale del packaging" },
    ],
    ctaTitle: "Dalla ricetta alla tavola", ctaText: "Scopri come trasformiamo l'innovazione in piatti gourmet pronti da servire.", ctaBtn: "Cosa facciamo",
  },
  whatWeDo: {
    crumb: "Cosa Facciamo", eyebrow: "Il processo produttivo", title: "Dalla ricetta alla tavola",
    subtitle: "Un ciclo produttivo che unisce l'arte dello Chef alla precisione della tecnologia, per una qualità costante in ogni piatto.",
    specs: [
      { value: "400+", label: "Ricette della tradizione" },
      { value: "150-200g", label: "Peso monoporzione" },
      { value: "+4° / -20°", label: "Abbattimento pos. e neg." },
    ],
    ctaTitle: "Scopri i nostri mercati", ctaText: "Nazionale e internazionale, con tre canali distributivi dedicati.", ctaBtn: "Mercati",
  },
  allf: {
    crumb: "Mercati", eyebrow: "Distribuzione", title: "ALLF: il ristorante italiano nel mondo",
    subtitle: "Vendita diretta, B2B e B2C. Portiamo i piatti gourmet ovunque, dal ristorante alla casa del cliente.",
    natTitle: "Mercato Nazionale", natText: "Rete di ristoranti e centri cottura ALLF Express distribuiti sul territorio italiano, con fornitura diretta a hotel, bar e ristoranti.",
    intlTitle: "Mercato Internazionale", intlText: "Grazie al brevetto esportiamo la food experience italiana in tutto il mondo, con qualità costante ovunque.",
    chanEyebrow: "I canali", chanTitle: "Tre modi per gustare MichelChef®",
    appBadge: "Digitale", appTitle: "Un'app perché l'appetito non ha tempo",
    appText: "Il mercato della ristorazione si sposta sempre di più verso una completezza di servizio. Oggi, per essere competitivi, bisogna sviluppare il business tramite delivery e take away: i locali non si valutano più dal numero dei coperti, ma dai servizi offerti.",
    appBtn: "Visita lo Shop",
    ctaTitle: "Diventa partner ALLF", ctaText: "Apri un punto ALLF o rifornisci il tuo locale con i nostri piatti gourmet.", ctaBtn: "Contattaci",
  },
  contact: {
    crumb: "Contatti", eyebrow: "Dove siamo", title: "Parliamone insieme",
    subtitle: "Hai un Hotel, un Bar o un Ristorante con problemi in cucina? Ci pensiamo noi. Scrivici o vieni a trovarci in una delle nostre sedi.",
    formTitle: "Scrivici", formSub: "Ti risponderemo il prima possibile.",
    nome: "Nome", email: "Email", tipo: "Tipo di attività", messaggio: "Messaggio",
    nomePh: "Il tuo nome", emailPh: "nome@email.it", msgPh: "Raccontaci di cosa hai bisogno...",
    tipoPlaceholder: "Seleziona...",
    tipoOpts: ["Hotel", "Bar", "Ristorante", "Privato / B2C", "Partner ALLF"],
    send: "Invia richiesta", sending: "Invio in corso...",
    sent: "Messaggio inviato! Ti ricontatteremo presto.",
    error: "Si è verificato un errore. Riprova più tardi.",
    directTitle: "Contatti diretti", mapTitle: "Le nostre sedi",
  },
  recipes: {
    crumb: "Ricette", eyebrow: "Piatti pronti gluten free", title: "La cucina italiana senza glutine",
    subtitle: "Piatti pronti genuini, 100% italiani, certificati gluten free. Pronti in soli 5 minuti. Esplora la nostra selezione per categoria.",
    searchPh: "Cerca un piatto...", all: "Tutti",
    total: "piatti pronti", showing: "In mostra", of: "di", results: "risultati",
    noResults: "Nessun piatto trovato per la tua ricerca.",
    categories: { primi: "Primi Piatti", sughi: "Sughi Pronti" },
  },
  hotel: {
    crumb: "Hotel & Ristorazione", eyebrow: "Cerchi uno chef?", title: "Ci pensiamo noi",
    subtitle: "Gestione cucina, costi certi e garanzia di risultato. Innovazione e qualità grazie al sistema PAQ di MichelChef®.",
    introTitle: "MichelChef® è innovazione assoluta",
    introText: "Abbiamo creato l'automazione dei processi di cottura per preservare le tradizioni culinarie italiane con un approccio innovativo, mantenendo sapori e aromi autentici in ogni piatto.",
    whyTitle: "Perché scegliere MichelChef®",
    why: [
      { t: "Cottura in 40 secondi", d: "Il tempo di preparazione si riduce drasticamente: servizio più veloce ed efficienza operativa." },
      { t: "Zero sprechi", d: "Gestione precisa e controllata degli ingredienti, per una cucina sostenibile." },
      { t: "Risultati standardizzati", d: "Ogni piatto cotto alla perfezione, senza variazioni di qualità." },
    ],
    sysTitle: "Il sistema PAQ", sysText: "Una rivoluzione per HORECA e HOTELLERIE: ottimizza il reparto cucina migliorando efficienza e qualità senza compromettere i costi. Completano il sistema XPAQ e PXPAQ.",
    systems: [
      { name: "PAQ", desc: "Processo Accelerato di Qualità: cottura rapida e costante." },
      { name: "XPAQ", desc: "Arricchisce i piatti con aromi e sapori intensi." },
      { name: "PXPAQ", desc: "Piatti base sviluppati appositamente per il sistema PAQ." },
    ],
    targetTitle: "A chi ci rivolgiamo",
    targets: [
      { name: "HORECA", desc: "Ristoranti, Bar, Street Food" },
      { name: "HOTELLERIE", desc: "Hotel, B&B, Agriturismo" },
      { name: "FORMAT & CATENE", desc: "Catene, linee aeree e ferroviarie, navi da crociera" },
    ],
    servTitle: "I nostri servizi", servText: "Vi accompagniamo verso un futuro culinario all'avanguardia, con tecnologia ed esperti al vostro fianco.",    services: [
      { t: "Fornitura del sistema PAQ", d: "Fornitura e installazione di strumenti all'avanguardia per un processo di cottura accelerato." },
      { t: "Gestione del reparto cucina", d: "Gestiamo personale e ingredienti attraverso il PAQ: voi vi concentrate sulla vostra passione." },
      { t: "Fornitura pasti su ricetta", d: "Pasti personalizzati su ricetta, grammatura e ingredienti secondo le vostre esigenze." },
    ],
    advTitle: "I vantaggi per i professionisti",
    clientsTitle: "Chi ha già scelto il sistema PAQ",
    advantages: [
      { n: "01", t: "Ottimizzazione dei costi", d: "Meno sprechi e risorse: margine di profitto più tutelato." },
      { n: "02", t: "Standardizzazione", d: "Stessa qualità su più sedi, senza variabili umane." },
      { n: "03", t: "Scalabilità", d: "Espandi il tuo modello di business con facilità." },
      { n: "04", t: "Formazione e supporto", d: "Formazione completa e assistenza continua per il team." },
      { n: "05", t: "Innovazione continua", d: "Ricerca e sviluppo costanti per restare all'avanguardia." },
    ],
    ctaTitle: "Ti gestiamo la cucina, con soli costi certi", ctaText: "Scopri se possiamo aiutarti: raccontaci la tua attività.", ctaBtn: "Contattaci",
  },
  risorice: {
    crumb: "Progetto RISORICE®", eyebrow: "Franchising · Cucina automatizzata", title: "RISORICE®: il ristorante che si serve da solo",
    subtitle: "Cucina italiana 100% gluten-free preparata da MICHELCHEF® con tecnologia MAGNETRON in 5 minuti e ritirata dal Food-Box Wall. Zero coda, zero contatti.",
    officialBtn: "Visita risorice.it", contactBtn: "Diventa partner",
    stats: [
      { value: "5 min", label: "Dall'ordine al piatto" },
      { value: "100%", label: "Gluten free · Spiga Barrata AIC" },
      { value: "+30%/anno", label: "Crescita mercato gluten-free" },
      { value: "220.000+", label: "Celiaci in Italia" },
    ],
    howTitle: "3 passi. 5 minuti. Zero attese.",
    how: [
      { n: "01", t: "Ordina dall'app", d: "Sfogli il menu, componi il tuo piatto e paghi in pochi secondi." },
      { n: "02", t: "MICHELCHEF® cucina", d: "La cottura MAGNETRON prepara il piatto in 5 minuti, sempre perfetto." },
      { n: "03", t: "Ritira dal Wall", d: "Sblocchi il tuo food-box con QR o PIN dall'app. Zero coda." },
    ],
    techTitle: "Cottura MAGNETRON automatizzata",
    techText: "Un sistema che bilancia potenza, tempo e umidità per ogni piatto: nessuna variabilità umana, qualità costante e velocità da fast-food.",
    techPoints: [
      "Sensori intelligenti con precisione ±1°C",
      "5 minuti da ordine confermato a piatto pronto",
      "Materie prime con shelf-life fino a 365 giorni",
      "Linea 100% gluten-free anti-contaminazione",
    ],
    wallTitle: "Food-Box Wall: il futuro del ritiro",
    wallText: "Il cuore dello store: un muro di food-box modulari termoregolati che il cliente sblocca con QR o PIN. Display LED, sensore di presenza e serrature smart.",
    advTitle: "I vantaggi del format",
    storesEyebrow: "I nostri locali", storesTitle: "In espansione in tutta Italia",
    stores: [
      { city: "Roma", address: "Via A. De Gasperi · vicino al Vaticano", opening: "Store pilota · Prossima apertura", service: "Solo Delivery & Take-Away", lat: 41.9074, lng: 12.4534 },
      { city: "Bologna", address: "Via Pradazzo · Zona Aeroporto", opening: "Apertura Q2 2026", service: "Posti a sedere · Delivery & Take-Away", lat: 44.5661, lng: 11.2361 },
      { city: "Milano", address: "Via Mercato, 10", opening: "Apertura Q3 2026", service: "Solo Delivery & Take-Away", lat: 45.4719, lng: 9.1876 },
    ],
    menuEyebrow: "I nostri piatti", menuTitle: "Menu 100% gluten free",
    menuNote: "Packaging biodegradabile · buoni SSN per celiaci accettati · pronti in 5 minuti.",
    glutenBadge: "Gluten Free", orderBtn: "Ordina ora",
    sim: {
      eyebrow: "Simulatore franchising",
      title: "Quanto puoi guadagnare con RISORICE®?",
      subtitle: "Stima ricavi, costi e utile del tuo store. Muovi i cursori in base alle tue ipotesi.",
      ticket: "Ticket medio", orders: "Ordini al giorno", days: "Giorni di apertura / mese",
      foodcost: "Food cost", rent: "Affitto mensile", staff: "Personale mensile",
      other: "Utenze e altri costi", royalty: "Royalty franchising",
      revenue: "Ricavi mensili", totalCosts: "Costi totali mensili", profit: "Utile mensile",
      yearly: "Utile annuo stimato", margin: "Margine",
      note: "Stima puramente indicativa: non costituisce offerta né garanzia di risultato.",
      scenarioName: "Nome scenario", compareTitle: "Confronto scenari", download: "Scarica report PDF", better: "Migliore",
      cta: "Richiedi info franchising",
      inputsLabel: "Parametri", resultsLabel: "Risultati",
      summaryTitle: "Riepilogo confronto", winnerMsg: "è più redditizio",
      tie: "I due scenari hanno lo stesso utile stimato.",
      perMo: "/mese", perYr: "/anno",
    },
    advantages: [
      { t: "100% Gluten Free", d: "Certificazione Spiga Barrata AIC, linea separata e tracciata." },
      { t: "Buoni SSN celiaci", d: "Accettati e rimborsati direttamente in store." },
      { t: "Zero coda", d: "Ritiro automatizzato dal Food-Box Wall con QR o PIN." },
      { t: "Qualità costante", d: "MAGNETRON: stesso risultato ad ogni piatto, senza chef." },
      { t: "Gestione con AI", d: "Ordini, riordini scorte, food-cost e customer insight automatizzati." },
      { t: "Franchising scalabile", d: "Un modello replicabile e a basso costo di gestione." },
    ],
    ctaTitle: "Apri il tuo RISORICE® in franchising", ctaText: "La cucina italiana gluten-free automatizzata: cottura MAGNETRON, AI e Food-Box Wall.", ctaBtn: "Contattaci",
  },
  locations: [
    { type: "Laboratorio", address: "Via Eridania Ovest, 65", city: "45030 Guarda Veneta (RO)", region: "Veneto - Italia", lat: 45.0447, lng: 11.7736 },
    { type: "Sede Legale", address: "P.zza Umberto I, 30", city: "44033 Riva del Po (FE)", region: "Emilia Romagna - Italia", lat: 44.9333, lng: 11.8167 },
    { type: "Show Room c/o ALLF", address: "Via Pradazzo, 7", city: "40012 Calderara di Reno (BO)", region: "Emilia Romagna - Italia", lat: 44.5661, lng: 11.2361 },
  ],
};

const en = {
  nav: { home: "Home", about: "About", innovation: "Innovation", whatWeDo: "What We Do", recipes: "Recipes", allf: "Markets", contact: "Contact" },
  common: { shop: "Shop", goShop: "Go to Shop", home: "Home", scroll: "Scroll", contactUs: "Contact us", discoverAllf: "Discover the RISORICE® project", docPdf: "PDF Document" },
  footer: {
    tagline: "Italian cuisine, reinvented through innovation. An innovative startup bringing Italian gourmet food all over the world.",
    naviga: "Navigate", progetti: "Projects",
    projects: [
      { label: "ALLF - The restaurant", key: "allf" },
      { label: "RISORICE® project", key: "risorice" },
      { label: "MichelChef® Hotel", key: "hotel" },
    ],
    dove: "Where we are", rights: "Innovative Startup VAT. All rights reserved.", italyWorld: "Italy & World",
  },
  home: {
    badge: "Innovative Startup since 2020",
    heroTitle1: "Italian cuisine,", heroTitle2: "reinvented.",
    heroSub: "Gourmet dishes in single portions, made by a Chef and regenerated anywhere thanks to a patent that preserves aromas and flavors. Innovation serving tradition.",
    heroCta1: "Discover the innovation", heroCta2: "Own a venue? We've got you covered",
    introEyebrow: "Who we are", introTitle: "What is MichelChef®",
    introP: [
      "MichelChef® is an innovative startup founded in March 2020 by Chef Michele Raccuia. A chef by passion from Turin, at 35 he took on a new challenge combining Passion, Technique and Vision in a project called ALLF.",
      "His idea of cooking completely disrupts the approach to Italian tables, creating a format made of high quality in small single portions.",
    ],
    introLink: "Our story",
    objEyebrow: "Innovation", objTitle: "Our goal",
    objText: "To export the traditions of Italian cuisine worldwide, always leveraging our patent that lets us preserve aromas and flavors, making the customer's food experience consistent everywhere.",
    objBadgeTitle: "Patent 2020", objBadgeSub: "Molecular spherification",
    objFeatures: [
      { t: "Global export", d: "Italian tradition everywhere" },
      { t: "Consistent food experience", d: "Same quality in every dish" },
    ],
    procEyebrow: "The process", procTitle: "How it works",
    procSub: "From the Chef's lab to the table, without ever losing quality.", procLink: "Discover the full process",
    chanEyebrow: "Markets & Distribution", chanTitle: "Three channels, one quality",
    ctaTitle: "Bring Italian gourmet cuisine to your venue",
    ctaText: "Hotel, Bar or Restaurant with kitchen problems? With MichelChef® and ALLF you serve gourmet dishes without needing a Chef.",
  },
  stats: [
    { value: "400+", label: "Traditional recipes" },
    { value: "2020", label: "Innovative Startup" },
    { value: "3", label: "Distribution channels" },
    { value: "150-200g", label: "Gourmet portions" },
  ],
  partners: ["Ristoranti & Delicatesse", "Chopped Italia", "Food Network", "LAINOX", "ALLF", "Ferrara Chamber of Commerce"],
  steps: [
    { step: "01", title: "Recipe creation", text: "The Chef creates his recipes inside the production lab. Over 400 recipes from the Italian culinary tradition." },
    { step: "02", title: "Blast chilling & packaging", text: "All dishes are blast chilled both positively (+4°) and negatively (-20°) and packaged in single portions with average weights of 150g to 200g." },
    { step: "03", title: "Shipping", text: "We ship to ALLF-branded restaurants, owned or affiliated, across Italy and worldwide." },
    { step: "04", title: "Automated cooking", text: "At ALLF points, gourmet dishes are regenerated with an automated cooking process, without a Chef, ensuring consistent quality." },
  ],
  channels: [
    { tag: "Direct", title: "ALLF Restaurants", text: "Direct sales through ALLF restaurants and ALLF Express cooking centers." },
    { tag: "B2B", title: "Hotels, Bars & Restaurants", text: "Supply to professional channels that want to offer gourmet cuisine without the chef problem." },
    { tag: "Distribution", title: "Horeca Distributors", text: "A network of Horeca distributors bringing our gourmet dishes to restaurants, bars and hotels across the country." },
  ],
  allfResto: {
    crumb: "ALLF · The restaurant",
    eyebrow: "Restaurant · Italian fast-casual",
    title: "ALLF: all of Italy in one bite, served in a flash",
    subtitle: "An all-Italian McDonald's: fast-food speed meets traditional cuisine. Regional dishes regenerated with an automated process, always consistent, in every location.",
    conceptEyebrow: "The concept",
    conceptTitle: "Like a fast-food, but 100% Italian cuisine",
    conceptText: "ALLF brings the great dishes of Italy's regions into the quick format you love: you order, the automated kitchen regenerates the dish in minutes and you pick it up. No chef on site, consistent gourmet quality everywhere.",
    pillars: [
      { t: "Fast-food fast", d: "Your dish ready in minutes, without giving up on taste." },
      { t: "Automated cooking", d: "The MichelChef® patent regenerates dishes with no chef on site." },
      { t: "Always consistent", d: "Same aroma and flavour in every ALLF, anywhere in the world." },
      { t: "All of Italy on the menu", d: "20 regions, 2 signature dishes each: 40 Italian specialties." },
    ],
    procEyebrow: "How it works",
    procTitle: "Order, ALLF handles the kitchen",
    proc: [
      { n: "01", t: "Order at the kiosk or app", d: "Pick a region and your dish in a few taps." },
      { n: "02", t: "Automated cooking", d: "The gourmet dish is regenerated in minutes, always perfect." },
      { n: "03", t: "Pick up and enjoy", d: "Grab your hot dish at the counter. Enjoy!" },
    ],
    menuEyebrow: "The regional menu",
    menuTitle: "A journey through Italy's 20 regions",
    menuNote: "Select a region to discover its 2 signature dishes.",
    regionsCount: "20 regions",
    dishesCount: "40 dishes",
    signatureLabel: "Signature dishes",
    ctaTitle: "Bring ALLF to your city",
    ctaText: "An Italian fast-casual format, automated and replicable. Discover how to open an ALLF restaurant.",
    ctaBtn: "Become a partner",
    officialBtn: "Visit allf.it",
  },
  about: {
    crumb: "About", eyebrow: "Who we are", title: "What is MichelChef®",
    subtitle: "Passion, Technique and Vision. The story of a Chef who decided to reinvent the way Italian cuisine reaches the world.",
    storyEyebrow: "The story", storyTitle: "From the Turin Chef to the ALLF project",
    storyExtra: "He then made all his know-how available by building a highly innovative project: a chain of Italian restaurants, all over the world, serving gourmet dishes through an automated cooking process and without a Chef on site.",
    quote: "\"Passion, Technique and Vision: combining them is the true recipe for innovation.\"",
    founder: "Chef Michele Raccuia",
    pathEyebrow: "The journey", pathTitle: "Key milestones",
    milestones: [
      { year: "2018", title: "LAINOX Ambassador", text: "Becomes ambassador of LAINOX, a leading Italian professional kitchen equipment company." },
      { year: "2018", title: "Ristoranti & Delicatesse", text: "Featured in the prestigious food & wine magazine." },
      { year: "2018", title: "Chopped Italia", text: "Takes part in the famous Food Network cooking show." },
      { year: "2020", title: "MichelChef® is born", text: "In March 2020 he founds the innovative startup with the ALLF project." },
    ],
    ctaTitle: "Want to know the innovation?", ctaText: "Discover the patent and technology that make our cuisine unique.", ctaBtn: "Discover the patent",
  },
  innovation: {
    crumb: "Innovation", eyebrow: "Patent & Technology", title: "Innovation in the kitchen",
    subtitle: "Molecular spherification and a patent that preserves aromas and flavors: this is how Italian tradition travels the world losing nothing.",
    date: "March 12, 2020", patentTitle: "The Patent",
    patentBody: "Chef Michele Raccuia presents at the Ferrara Chamber of Commerce and, before a commission, shows his kitchen innovation through molecular spherification. At the end of the presentation the commission registers MichelChef® S.r.l. in the Innovative Startups section.",
    patentExtraPre: "A process that allows dishes to be blast chilled and regenerated while keeping the ",
    patentExtraHi: "food experience",
    patentExtraPost: " intact: same aroma, same flavor, anywhere in the world.",
    regEyebrow: "Registrations", regTitle: "Protected and certified",
    regSub: "MichelChef® S.r.l. is registered in the Innovative Startups section of the Ferrara Chamber of Commerce.",
    registrations: [
      { label: "Trademark", desc: "Registration of the filed trademark" },
      { label: "Patent", desc: "Aroma & flavor preservation process" },
      { label: "Design", desc: "Industrial design of the packaging" },
    ],
    ctaTitle: "From recipe to table", ctaText: "See how we turn innovation into gourmet dishes ready to serve.", ctaBtn: "What we do",
  },
  whatWeDo: {
    crumb: "What We Do", eyebrow: "The production process", title: "From recipe to table",
    subtitle: "A production cycle that blends the Chef's art with the precision of technology, for consistent quality in every dish.",
    specs: [
      { value: "400+", label: "Traditional recipes" },
      { value: "150-200g", label: "Portion weight" },
      { value: "+4° / -20°", label: "Pos. & neg. blast chilling" },
    ],
    ctaTitle: "Discover our markets", ctaText: "National and international, with three dedicated distribution channels.", ctaBtn: "Markets",
  },
  allf: {
    crumb: "Markets", eyebrow: "Distribution", title: "ALLF: the Italian restaurant worldwide",
    subtitle: "Direct sales, B2B and B2C. We bring gourmet dishes everywhere, from the restaurant to the customer's home.",
    natTitle: "National Market", natText: "A network of ALLF restaurants and ALLF Express cooking centers across Italy, with direct supply to hotels, bars and restaurants.",
    intlTitle: "International Market", intlText: "Thanks to the patent we export the Italian food experience worldwide, with consistent quality everywhere.",
    chanEyebrow: "The channels", chanTitle: "Three ways to enjoy MichelChef®",
    appBadge: "Digital", appTitle: "An app, because appetite has no schedule",
    appText: "The restaurant market is shifting more and more towards complete service. Today, to be competitive, you must develop business through delivery and take away: venues are no longer judged by the number of seats, but by the services offered.",
    appBtn: "Visit the Shop",
    ctaTitle: "Become an ALLF partner", ctaText: "Open an ALLF point or supply your venue with our gourmet dishes.", ctaBtn: "Contact us",
  },
  contact: {
    crumb: "Contact", eyebrow: "Where we are", title: "Let's talk",
    subtitle: "Do you have a Hotel, Bar or Restaurant with kitchen problems? We've got you covered. Write to us or visit one of our locations.",
    formTitle: "Write to us", formSub: "We'll get back to you as soon as possible.",
    nome: "Name", email: "Email", tipo: "Type of business", messaggio: "Message",
    nomePh: "Your name", emailPh: "name@email.com", msgPh: "Tell us what you need...",
    tipoPlaceholder: "Select...",
    tipoOpts: ["Hotel", "Bar", "Restaurant", "Private / B2C", "ALLF Partner"],
    send: "Send request", sending: "Sending...",
    sent: "Message sent! We'll get back to you soon.",
    error: "Something went wrong. Please try again later.",
    directTitle: "Direct contacts", mapTitle: "Our locations",
  },
  recipes: {
    crumb: "Recipes", eyebrow: "Gluten free ready meals", title: "Italian cuisine, gluten free",
    subtitle: "Genuine ready meals, 100% Italian, certified gluten free. Ready in just 5 minutes. Explore our selection by category.",
    searchPh: "Search a dish...", all: "All",
    total: "ready meals", showing: "Showing", of: "of", results: "results",
    noResults: "No dish found for your search.",
    categories: { primi: "First Courses", sughi: "Ready Sauces" },
  },
  hotel: {
    crumb: "Hotel & Foodservice", eyebrow: "Looking for a chef?", title: "We've got you covered",
    subtitle: "Kitchen management, fixed costs and guaranteed results. Innovation and quality with MichelChef®'s PAQ system.",
    introTitle: "MichelChef® is pure innovation",
    introText: "We created the automation of cooking processes to preserve Italian culinary traditions with an innovative approach, keeping authentic flavors and aromas in every dish.",
    whyTitle: "Why choose MichelChef®",
    why: [
      { t: "Cooking in 40 seconds", d: "Preparation time drops dramatically: faster service and operational efficiency." },
      { t: "Zero waste", d: "Precise, controlled ingredient management for a sustainable kitchen." },
      { t: "Standardized results", d: "Every dish cooked to perfection, with no quality variation." },
    ],
    sysTitle: "The PAQ system", sysText: "A revolution for HORECA and HOTELLERIE: it optimizes the kitchen department improving efficiency and quality without compromising costs. Completed by XPAQ and PXPAQ.",
    systems: [
      { name: "PAQ", desc: "Accelerated Quality Process: fast and consistent cooking." },
      { name: "XPAQ", desc: "Enriches dishes with intense aromas and flavors." },
      { name: "PXPAQ", desc: "Base dishes developed specifically for the PAQ system." },
    ],
    targetTitle: "Who we serve",
    targets: [
      { name: "HORECA", desc: "Restaurants, Bars, Street Food" },
      { name: "HOTELLERIE", desc: "Hotels, B&Bs, Farm stays" },
      { name: "FORMAT & CHAINS", desc: "Chains, airlines and railways, cruise ships" },
    ],
    servTitle: "Our services", servText: "We guide you towards a cutting-edge culinary future, with technology and experts by your side.",
    services: [
      { t: "PAQ system supply", d: "Supply and installation of cutting-edge tools for an accelerated cooking process." },
      { t: "Kitchen department management", d: "We manage staff and ingredients via PAQ: you focus on your passion." },
      { t: "Meals on recipe", d: "Custom meals by recipe, grammage and ingredients to fit your needs." },
    ],
    advTitle: "Advantages for professionals",
    clientsTitle: "Who already chose the PAQ system",
    advantages: [
      { n: "01", t: "Cost optimization", d: "Less waste and resources: a more protected profit margin." },
      { n: "02", t: "Standardization", d: "Same quality across locations, without human variables." },
      { n: "03", t: "Scalability", d: "Expand your business model with ease." },
      { n: "04", t: "Training & support", d: "Complete training and ongoing support for your team." },
      { n: "05", t: "Continuous innovation", d: "Constant R&D to stay at the cutting edge." },
    ],
    ctaTitle: "We manage your kitchen, with fixed costs only", ctaText: "Find out if we can help you: tell us about your business.", ctaBtn: "Contact us",
  },
  risorice: {
    crumb: "RISORICE® project", eyebrow: "Franchising · Automated kitchen", title: "RISORICE®: the restaurant that serves itself",
    subtitle: "Italian cuisine, 100% gluten-free, prepared by MICHELCHEF® with MAGNETRON technology in 5 minutes and picked up from the Food-Box Wall. Zero queue, zero contact.",
    officialBtn: "Visit risorice.it", contactBtn: "Become a partner",
    stats: [
      { value: "5 min", label: "From order to dish" },
      { value: "100%", label: "Gluten free · AIC certified" },
      { value: "+30%/yr", label: "Gluten-free market growth" },
      { value: "220,000+", label: "Celiacs in Italy" },
    ],
    howTitle: "3 steps. 5 minutes. Zero waiting.",
    how: [
      { n: "01", t: "Order from the app", d: "Browse the menu, build your dish and pay in seconds." },
      { n: "02", t: "MICHELCHEF® cooks", d: "MAGNETRON cooking prepares your dish in 5 minutes, always perfect." },
      { n: "03", t: "Pick up from the Wall", d: "Unlock your food-box with QR or PIN from the app. Zero queue." },
    ],
    techTitle: "Automated MAGNETRON cooking",
    techText: "A system balancing power, time and humidity for every dish: no human variability, consistent quality and fast-food speed.",
    techPoints: [
      "Smart sensors with ±1°C precision",
      "5 minutes from confirmed order to ready dish",
      "Ingredients with shelf-life up to 365 days",
      "100% gluten-free anti-contamination line",
    ],
    wallTitle: "Food-Box Wall: the future of pickup",
    wallText: "The heart of the store: a wall of modular temperature-controlled food-boxes the customer unlocks with QR or PIN. LED display, presence sensor and smart locks.",
    advTitle: "The format's advantages",
    storesEyebrow: "Our stores", storesTitle: "Expanding across Italy",
    stores: [
      { city: "Rome", address: "Via A. De Gasperi · near the Vatican", opening: "Pilot store · Opening soon", service: "Delivery & Take-Away only", lat: 41.9074, lng: 12.4534 },
      { city: "Bologna", address: "Via Pradazzo · Airport area", opening: "Opening Q2 2026", service: "Seating · Delivery & Take-Away", lat: 44.5661, lng: 11.2361 },
      { city: "Milan", address: "Via Mercato, 10", opening: "Opening Q3 2026", service: "Delivery & Take-Away only", lat: 45.4719, lng: 9.1876 },
    ],
    menuEyebrow: "Our dishes", menuTitle: "100% gluten free menu",
    menuNote: "Biodegradable packaging · celiac SSN vouchers accepted · ready in 5 minutes.",
    glutenBadge: "Gluten Free", orderBtn: "Order now",
    sim: {
      eyebrow: "Franchise simulator",
      title: "How much could you earn with RISORICE®?",
      subtitle: "Estimate revenue, costs and profit of your store. Move the sliders based on your assumptions.",
      ticket: "Average ticket", orders: "Orders per day", days: "Open days / month",
      foodcost: "Food cost", rent: "Monthly rent", staff: "Monthly staff",
      other: "Utilities & other costs", royalty: "Franchise royalty",
      revenue: "Monthly revenue", totalCosts: "Total monthly costs", profit: "Monthly profit",
      yearly: "Estimated yearly profit", margin: "Margin",
      note: "Purely indicative estimate: not an offer or guarantee of results.",
      scenarioName: "Scenario name", compareTitle: "Scenario comparison", download: "Download PDF report", better: "Best",
      cta: "Request franchise info",
      inputsLabel: "Parameters", resultsLabel: "Results",
      summaryTitle: "Comparison summary", winnerMsg: "is more profitable",
      tie: "The two scenarios have the same estimated profit.",
      perMo: "/mo", perYr: "/yr",
    },
    advantages: [
      { t: "100% Gluten Free", d: "AIC certified, separate and traced production line." },
      { t: "Celiac SSN vouchers", d: "Accepted and reimbursed directly in store." },
      { t: "Zero queue", d: "Automated pickup from the Food-Box Wall with QR or PIN." },
      { t: "Consistent quality", d: "MAGNETRON: same result on every dish, no chef needed." },
      { t: "AI management", d: "Orders, stock re-ordering, food-cost and customer insight automated." },
      { t: "Scalable franchising", d: "A replicable model with low running costs." },
    ],
    ctaTitle: "Open your own RISORICE® franchise", ctaText: "Automated gluten-free Italian cuisine: MAGNETRON cooking, AI and Food-Box Wall.", ctaBtn: "Contact us",
  },
  locations: [
    { type: "Laboratory", address: "Via Eridania Ovest, 65", city: "45030 Guarda Veneta (RO)", region: "Veneto - Italy", lat: 45.0447, lng: 11.7736 },
    { type: "Registered Office", address: "P.zza Umberto I, 30", city: "44033 Riva del Po (FE)", region: "Emilia Romagna - Italy", lat: 44.9333, lng: 11.8167 },
    { type: "Show Room at ALLF", address: "Via Pradazzo, 7", city: "40012 Calderara di Reno (BO)", region: "Emilia Romagna - Italy", lat: 44.5661, lng: 11.2361 },
  ],
};

export const translations = { it, en };
